module.exports = __webpack_public_path__ + "assets/chevron-left-plain.26180b20.svg";